/* @flow */

import React from 'react';
import { Modal, Grid, Button, Header } from 'semantic-ui-react';
import { onSubmitActions } from 'redux-form-submit-saga';
import { SAVE_PAGE } from 'catalog/actions/pages';
import CreatePageForm from './CreatePageForm';

type Props = {
  visible: boolean,
  onSelected: (page: CatalogPage) => void,
  onSwitchMode: () => void,
  onClose: () => void,
};

const styles = {
  content: {
    display: 'block',
    width: '100%',
    fontSize: '1em',
    lineHeight: '1.4',
    padding: '1.5rem',
    background: '#fff',
  },
  actions: {
    background: '#f9fafb',
    padding: '1rem 1rem',
    borderTop: '1px solid rgba(34,36,38,.15)',
    textAlign: 'right',
    borderBottomLeftRadius: '.28571429rem',
    borderBottomRightRadius: '.28571429rem',
  },
  submit: {
    marginLeft: '.75em',
    marginBottom: '1rem',
  },
};

const CreatePageModal = ({
  visible,
  onClose,
  onSelected,
  onSwitchMode,
}: Props) => {
  const submit = (values, dispatch) =>
    onSubmitActions(SAVE_PAGE)(values, dispatch).then(onSelected);

  return (
    <Modal open={visible} onClose={onClose} closeIcon>
      <Modal.Header>
        <Grid columns={2}>
          <Grid.Column>
            <Header>Création de page</Header>
          </Grid.Column>
          <Grid.Column>
            <Button
              onClick={onSwitchMode}
              floated="right"
              labelPosition="left"
              icon="close"
              content="Annuler la création"
            />
          </Grid.Column>
        </Grid>
      </Modal.Header>
      <CreatePageForm onSubmit={submit}>
        {({ fields, submitting, pristine }) => (
          <div>
            <Modal.Content style={styles.content}>{fields}</Modal.Content>
            <Modal.Actions style={styles.actions}>
              <Button
                style={styles.submit}
                content="Enregistrer et sélectionner"
                disabled={pristine}
                loading={submitting}
                primary
                floated="right"
                icon="save"
                labelPosition="left"
              />
            </Modal.Actions>
          </div>
        )}
      </CreatePageForm>
    </Modal>
  );
};

export default CreatePageModal;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/CreatePageModal.js